module.exports = __webpack_public_path__ + "img/P11a_39824078.00003ad7.jpg";